module.exports = __webpack_public_path__ + "media/images/icon-checkbox-off-d24504f3a4fc071be322980954dbbf32.svg";